import { defineStore } from "pinia";

export const useMessageStore = defineStore({
	id: "message-store",
	state: () => {
		return {
            showMessageModal: false,
            title: '',
            message: '',
            community: false,
            saibamais: false,
		}
	},
	actions: {
		toggleMessageModal () {
            this.showMessageModal = !this.showMessageModal
        },
        toggleMessage(val: string){
            this.message = val
        },
        toggleTitle(val: string) {
            this.title = val
        },
        toggleCommunity(val: boolean){
            this.community = val
        },
        toggleSaibamais(val: boolean) {
            this.saibamais = val
        },
        toggleObject(val: any) {
            this.showMessageModal = !this.showMessageModal
            this.message = val.message
            this.title = val.title
            this.community = val.community
            this.saibamais = val.saibamais
        },
	},
	getters: {
	}
})

if(import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useMessageStore, import.meta.hot));
}